export enum DocumentRequestTypes {
	LoanApplicationDocumentRequest = 1,
	DocumentRequest
}
